import { handleColorType } from '@quizzach/styles';
import { useState } from 'react';
import { useTheme } from 'styled-components';

export const ThumbsDown = ({
	color,
	size,
}: {
	color?: string;
	size?: number;
}) => {
	const [isHovered, setIsHovered] = useState(false);
	const theme = useTheme();

	return (
		<svg
			width={size || '42'}
			height={size || '42'}
			viewBox='0 0 42 42'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			onMouseEnter={() => setIsHovered(true)}
			onMouseLeave={() => setIsHovered(false)}
			onTouchStart={() => setIsHovered(false)}
			onTouchEnd={() => setIsHovered(false)}
			style={{
				transform: isHovered ? 'scale(1.1)' : 'scale(1)',
				transition: 'transform 0.3s ease, fill 0.3s ease',
			}}
		>
			<path
				d='M40.3323 26.9073C39.9529 26.658 41.6671 27.4479 36.8708 25.1435C36.035 24.81 34.089 23.9126 33.2037 23.763M33.2037 23.763C32.1991 23.5933 31.95 24.0207 31.2502 24.9573C31.0357 25.2444 29.3159 27.1906 29.0666 27.4479C28.8265 27.6959 27.6516 28.7963 26.8259 33.2603C26.7575 33.8782 26.6447 34.4862 26.5796 35.1061C26.5552 35.338 26.5581 35.5642 26.5466 35.7963C26.5327 36.0758 26.4515 36.3488 26.4323 36.6273C26.3782 37.4082 25.9637 38.294 25.4273 38.8478C24.9526 39.3379 24.2586 39.8388 23.589 39.958C22.6341 40.128 20.3101 39.8218 18.9821 38.2938C18.1552 37.3547 17.6367 36.0827 17.4648 34.8405C17.352 34.0248 17.4934 28.8628 17.4934 28.0405C17.4537 27.4887 17.4744 26.9108 17.5154 26.3604C17.5526 25.861 17.6106 25.3634 17.6869 24.871C17.7137 24.698 17.8025 24.5256 17.8716 24.367C17.9164 24.2642 17.8763 24.1204 17.9112 24.0082C17.9392 23.9182 18.1422 23.8788 18.3186 23.8595M33.2037 23.763C33.078 23.8988 33.0529 2.78907 33.0529 4.45754C31.009 4.51165 18.3869 1.41088 14.3825 2.09998C2.36818 3.47816 2.73703 8.34536 1.62278 12.9472C-0.37944 21.2163 2.95864 22.5944 4.43147 23.2835C5.6272 23.7562 5.80167 23.6549 6.40098 23.754C7.30429 23.8161 12.0642 23.8519 12.9697 23.8402C13.6753 23.8311 15.8658 23.754 16.5742 23.754C16.8584 23.754 17.1434 23.7472 17.4274 23.7562C17.7266 23.7657 18.0216 23.8285 18.3186 23.8595M33.2037 23.763C33.3604 23.5939 32.9308 4.57335 33.1295 4.45754C33.0521 5.36598 35.6608 1.41088 41 2.09998M18.3186 23.8595C18.4232 23.8481 18.5185 23.8438 18.5621 23.8402C18.8621 23.8159 20.1207 23.8577 20.4137 23.8766C20.6621 23.8926 19.7851 23.9174 19.4461 23.9174C19.1567 23.9174 18.8729 23.8811 18.5841 23.8766C18.4953 23.8752 18.4068 23.8687 18.3186 23.8595Z'
				stroke={
					isHovered
						? '#00FFC2'
						: color
							? handleColorType(color, theme)
							: '#00FFC2'
				}
				strokeWidth='2'
				strokeLinecap='round'
			/>
		</svg>
	);
};
